import { Controller } from '@hotwired/stimulus'

// Feuille de partage système (navigator.share). L’élément reste masqué
// tant que l’API n’existe pas (desktop, vieux navigateurs).
export default class extends Controller {
  static values = { url: String, title: String }

  connect() {
    if (navigator.share) this.element.classList.remove('hidden')
  }

  share() {
    // Rejet silencieux : fermer la feuille sans choisir est un geste normal.
    navigator.share({ title: this.titleValue, url: this.urlValue }).catch(() => {})
  }
}
